import clsx from "clsx";
import { pick } from "lodash";
import { RenderWhen, ThreatStatusLabel } from "../../../../../../components";
import {
  useGetSampleAnalysisStatus,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { Configure, Loading } from "../../components";

import { SandboxAnalysisItem } from "../../../../@types";
import { getIsNotConfigured } from "../../utils";
import styles from "../analysis-card.module.scss";

type Props = {
  data: Array<SandboxAnalysisItem | null>;
  decisive: boolean;
  classification?: string;
};

const getMaliciousCount = (integrations: Array<SandboxAnalysisItem | null>) =>
  integrations
    ?.filter(Boolean)
    .filter(item => item?.classification?.toLowerCase() === "malicious").length;

const getResultsCount = (integrations: Array<SandboxAnalysisItem | null>) =>
  integrations.filter(Boolean).filter(item => item?.classification).length;

const Subtitle = ({ data, decisive, classification }: Props) => {
  const { hash } = useLocalSampleSummaryParams();
  const { data: { dynamic_analysis: analysis = undefined } = {}, isLoading } =
    useGetSampleAnalysisStatus(hash);

  const showNoAnalysisLabel = !data.find(item => Boolean(item?.classification));

  const maliciousCount = getMaliciousCount(data);
  const resultsCount = getResultsCount(data);

  const enabledCount = Object.values(
    pick(analysis, [
      "cuckoo",
      "cape",
      "joe",
      "fireeye",
      "vmray_tcbase",
      "cisco_secure_malware_analytics"
    ])
  ).filter(item => !getIsNotConfigured(item?.additional_information)).length;

  if (isLoading) return <Loading />;

  if (!showNoAnalysisLabel)
    return (
      <div className="flex align-center flex-gap-1">
        <ThreatStatusLabel
          className={styles.analysis_card_subtitle_classification}
          labelText={`${maliciousCount}/${Math.max(
            enabledCount,
            resultsCount
          )} Malicious`}
          threatStatus={maliciousCount ? "malicious" : "unknown"}
          showOrb={false}
          showColor
        />
        <RenderWhen condition={Boolean(decisive)}>
          <span
            className={clsx(
              styles.decisive_reason_label,
              styles[classification ?? ""]
            )}
          >
            (Decisive)
          </span>
        </RenderWhen>
      </div>
    );

  if (enabledCount)
    return <span className={styles.analysis_card_subtitle}>No Analysis</span>;

  return <Configure type="INTEGRATION" />;
};

export default Subtitle;
